import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import sbhrpLabMembers from '../data/sbhrpLabMembers';
import useTranslation from '../utils/useTranslation';
import Header from './Header';
import Footer from './Footer';

const MEMBER_PLACEHOLDER_ICON = (
  <svg
    viewBox="0 0 24 24"
    width="56"
    height="56"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M5 20a7 7 0 0 1 14 0" />
  </svg>
);

function SbhrpMemberCard({ member, projectLabel }) {
  return (
    <article className="sbhrp-member-card">
      <div className="sbhrp-member-photo">
        {member.image ? (
          <img src={member.image} alt={member.name} loading="lazy" decoding="async" />
        ) : (
          <span className="sbhrp-member-photo-fallback">{MEMBER_PLACEHOLDER_ICON}</span>
        )}
      </div>
      <div className="sbhrp-member-body">
        <h2 className="sbhrp-member-name">{member.name}</h2>
        <p className="sbhrp-member-project">
          <span className="sbhrp-member-project-label">{projectLabel}</span>
          {member.project}
        </p>
      </div>
    </article>
  );
}

export default function SbhrpLabMembersPage() {
  const { lang } = useTranslation();
  const navigate = useNavigate();
  const content = sbhrpLabMembers[lang] || sbhrpLabMembers.ar;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const handleNavigate = (sectionId) => {
    if (sectionId === 'home') {
      navigate('/');
      return;
    }
    if (sectionId === 'about' || sectionId === 'laws') return;
    navigate('/', { state: { scrollTo: sectionId } });
  };

  return (
    <div className="news-list-page sbhrp-page sbhrp-lab-members-page">
      <Header active="home" onNavigate={handleNavigate} />

      <main className="container sbhrp-lab-members-main">
        <header className="sbhrp-lab-members-head">
          <h1 className="sbhrp-lab-members-title">{content.pageTitle}</h1>
        </header>

        <div className="sbhrp-member-grid">
          {content.members.map((member) => (
            <SbhrpMemberCard key={member.id} member={member} projectLabel={content.projectLabel} />
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
